module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-content/welcome-carousel/outlook-template-callout.svg"